// ** Third Party Components
import styled, { css } from "styled-components";
import Block from "components/layout/Block";

//##################################

export const BottomPanelStyled = styled("div")`
	position: absolute;
	display: flex;
	flex-direction: row;
	justify-content: end;
	z-index: 2;
	bottom: 0.75rem;
	right: 1rem;
	${({ fullscreen }) =>
		fullscreen &&
		css`
			position: absolute;
			bottom: 0;
			left: 0;
			right: 0;
		`}
`;

export const BottomPanelSide = styled("div")`
	display: flex;
	flex-direction: column;
	align-items: end;
`;
//##################################

const BottomPanel = ({
	controlCameraButton,
	controlMuteStreamButton,
	cameraSwitchingButton,
	controlVolume,
	controlFullscreenButton,
	fullscreen,
}) => {
	return (
		<BottomPanelStyled fullscreen={fullscreen}>
			<BottomPanelSide>
				{typeof cameraSwitchingButton === "function" ? (
					<Block>{cameraSwitchingButton()}</Block>
				) : null}
				<Block>{controlCameraButton()}</Block>
				<Block>{controlMuteStreamButton()}</Block>
				{typeof controlFullscreenButton === "function" ? (
					<Block>{controlFullscreenButton()}</Block>
				) : null}
				<Block>{controlVolume()}</Block>
			</BottomPanelSide>
		</BottomPanelStyled>
	);
};

export default BottomPanel;
